/**
 * 从数字或「USD 12.5」类文案里抽出可比较的价格数值。
 */
export function parsePriceNumber(value) {
  if (value == null || value === '' || value === '—') return null;
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;
  const text = String(value).trim();
  if (!text || text === '—') return null;
  const match = text.match(/-?\d+(?:\.\d+)?/);
  if (!match) return null;
  const n = Number(match[0]);
  return Number.isFinite(n) ? n : null;
}

function extractCurrency(value, fallback = '') {
  if (value != null && typeof value === 'object' && !Array.isArray(value)) {
    const fromField = String(value.currency || '').trim();
    if (fromField) return fromField;
    return extractCurrency(value.priceText ?? value.value ?? value.price, fallback);
  }
  const text = String(value || '').trim();
  const match = text.match(/^([A-Za-z]{3})\b/);
  return match ? match[1] : String(fallback || '').trim();
}

function formatPriceNumber(n) {
  if (!Number.isFinite(n)) return '';
  return Math.abs(n - Math.round(n)) < 1e-9 ? String(Math.round(n)) : n.toFixed(2);
}

/**
 * 价格展示：全部相同则显示一个值；不同则取最小~最大作为范围。
 *
 * 入参支持：
 * - 数字 / 数字字符串 / 「USD 10」文案
 * - `{ value|price|salePrice|supplyPrice|priceText, currency? }`
 *
 * @returns {string} 如 `USD 10`、`USD 10~20`，无有效价格时 `—`
 */
export function formatPriceRangeDisplay(entries, fallbackCurrency = '') {
  const nums = [];
  let currency = String(fallbackCurrency || '').trim();

  (Array.isArray(entries) ? entries : []).forEach((entry) => {
    if (entry == null || entry === '' || entry === '—') return;
    if (typeof entry === 'object' && !Array.isArray(entry)) {
      const raw = entry.value
        ?? entry.price
        ?? entry.salePrice
        ?? entry.supplyPrice
        ?? entry.priceText;
      const n = parsePriceNumber(raw);
      if (n == null) return;
      nums.push(n);
      if (!currency) currency = extractCurrency(entry, '');
      return;
    }
    const n = parsePriceNumber(entry);
    if (n == null) return;
    nums.push(n);
    if (!currency) currency = extractCurrency(entry, '');
  });

  if (!nums.length) return '—';
  const min = Math.min(...nums);
  const max = Math.max(...nums);
  const prefix = currency ? `${currency} ` : '';
  if (min === max) return `${prefix}${formatPriceNumber(min)}`;
  return `${prefix}${formatPriceNumber(min)}~${formatPriceNumber(max)}`;
}
